import * as React from 'react';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Role } from '../types/members-types';
import { Box, Typography } from '@mui/material';

export interface IRolesAutocompleteProps {
  availableRoles: Role[];
  selectedRoles: Role[];
  handleOnChangeRole: (newRoles: Role[]) => void;
}

const RolesAutocomplete: React.FC<
  React.PropsWithChildren<IRolesAutocompleteProps>
> = ({ availableRoles, selectedRoles, handleOnChangeRole }) => {
  return (
    <Autocomplete
      multiple
      id='fixed-tags-demo'
      value={selectedRoles}
      onChange={(_, newRoles) => handleOnChangeRole(newRoles)}
      options={availableRoles}
      renderOption={(props, option) => (
        <Box component='li' {...props}>
          <Box flexDirection='column'>
            <Typography
              variant='body2'
              color='textPrimary'
              sx={{ fontWeight: 'bold' }}>
              {option.name}
            </Typography>
            <Typography variant='body2' color='textPrimary'>
              {option.description}
            </Typography>
          </Box>
        </Box>
      )}
      getOptionLabel={option => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip label={option.name} {...getTagProps({ index })} />
        ))
      }
      style={{ width: '100%' }}
      renderInput={params => <TextField {...params} label='Assign a role' />}
    />
  );
};

export default RolesAutocomplete;
